export default {
//随三个图片之一显示
randomPic:function() {
    var tagHash = [
      // cover1
      {
        //随机生成的图片
        imgUrl: "cover1.png",
      },
      // cover2
      {
        imgUrl: "cover2.png",
      },
      // cover3
      {
        imgUrl: "cover3.png",
      },
    ];
    let randomKeys = [0, 1, 2];
    let index = Math.floor(Math.random() * 3);
    return require("@/assets/imgs/"+tagHash[randomKeys[index]].imgUrl)
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js